module.exports = __webpack_public_path__ + "img/tree-06-e-trunk.7d177fe7.png";